import styled from "styled-components";
import { mobile } from "../../_themes/constants/";
import { CloseButton } from "../../CloseButton";

export const StyledCloseButton = styled(CloseButton)`
  display: inherit;
  flex: 1;
  justify-content: center;
  align-items: center;

  svg {
    @media (orientation: landscape) {
      width: ${mobile.landscape.sidePanel.icon.width};
      height: ${mobile.landscape.sidePanel.icon.height};
    }

    @media (orientation: portrait) {
      width: ${mobile.portrait.middlePanel.footer.icon.width};
      height: ${mobile.portrait.middlePanel.footer.icon.height};
    }
  }
`;
